import { createSlice } from '@reduxjs/toolkit';
import { ProjectModel, SinglePackage } from '../models/project';
import { getProject } from '../pages/Projects/fakeApi';
import { deepSearchForPackage, updatePackage } from '../utils/handleProject';
import { Node } from 'reactflow';
import { toast } from 'react-toastify';
import { getAllComponents, getAllPackages } from '../pages/DigramCreator/components/helpersFN';

type IProject = {
  prevPkgNamebeforeEdit: string | null,
  PkgNameAfterEdit: string | null,
  currentProject: ProjectModel | null;
  tempProject: ProjectModel | null;
  currentPackageName: string;
  currentPackages: SinglePackage[];
  allPackages: any[],
  deletedPkg: SinglePackage,
  allDeletedPkgs:SinglePackage[],
  allComponents: any[],
  rerenderValue:number
};

const initialState: IProject = {
  prevPkgNamebeforeEdit: null,
  PkgNameAfterEdit: null,
  currentProject: null,
  tempProject: null,
  currentPackageName: '',
  currentPackages: [],
  allPackages: [],
  deletedPkg:null,
  allDeletedPkgs: [],
  allComponents: [],
  rerenderValue:0,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    reset(state) {
      state.prevPkgNamebeforeEdit= null;
      state.PkgNameAfterEdit= null;
      state.currentProject = null;
      state.tempProject= null;
      state.currentPackageName= '';
      state.currentPackages = [];
      state.allPackages= [];
      state.deletedPkg= null;
      state.allDeletedPkgs= [];
      state.allComponents= [];
      state.rerenderValue = 0;
    },
    initProject(state, {payload}: {payload: string}) {
      const project = getProject(payload)
      state.currentProject = {...project};
      state.tempProject = {...project};
      state.currentPackageName = project?.basePackage?.packageName;
      // Populate allPackages when project is initialized
      if (project?.basePackage) {
        state.allPackages = getAllPackages(project.basePackage);
      }
    },
    updateCurrentProject(state) {
      state.currentProject = JSON.parse(JSON.stringify(state.tempProject));
    },
    updataTempMetaData(state, {payload}) {
      state.prevPkgNamebeforeEdit= state.tempProject.basePackage?.packageName;
      if (state.tempProject) {
        state.tempProject = {
          ...state.tempProject,
          metaData: payload,
          basePackage: {
            ...state.tempProject.basePackage,
            packageName: payload.packageName
          }
        }
        state.currentProject = {
          ...state.currentProject,metaData: payload,basePackage: {
            ...state.currentProject.basePackage,
            packageName: payload.packageName
          }}
      }
      state.PkgNameAfterEdit= payload.packageName;
      state.currentPackageName = payload.packageName;
    },
    addTempProject(state,{payload}) {
      state.tempProject = payload;
      // Populate allPackages when project is loaded
      if (payload?.basePackage) {
        state.allPackages = getAllPackages(payload.basePackage);
      }
    },
    updateTempProject(state, {payload: {nodes, pkgName, pkgs}}: {payload: {pkgName: string; nodes?: Node<any, string>[], pkgs?: SinglePackage[]}}) {
      if (!state.tempProject?.basePackage) {
        return;
      }
      const basePackage = updatePackage(
        state.tempProject?.basePackage,
        "packageName",
        pkgName,
        nodes,
        pkgs
      );
      if (basePackage) {
        state.tempProject = JSON.parse(JSON.stringify({ ...state.tempProject, basePackage }));
        state.allComponents = getAllComponents(state.tempProject?.basePackage) ?? [];
        // Update allPackages when project structure changes
        state.allPackages = getAllPackages(state.tempProject?.basePackage) ?? [];
      }
      if (pkgs?.length > 0) {
        state.currentPackages = pkgs;
      }
    },
    
    updateRerenderValue(state){
      state.rerenderValue = state.rerenderValue + 1
    },
    
    handleUpdateCurrentPackages(state, {payload}: {payload: SinglePackage[]}) {
      state.currentPackages = payload;
    },
    handleUpdateAllPackages(state, {payload}: {payload: any[]}) {
      state.allPackages = payload;
    },
    handleChangeCurrentPackage(state, {payload}: {payload:string}) {
      state.currentPackageName = payload;
     
      
      const pkg = deepSearchForPackage(state.tempProject?.basePackage, payload);
     
      
      state.currentPackages = [...(pkg?.childrenPackages.length > 0 ? pkg?.childrenPackages : [])];
    },
 
    handleChangePkgName(state, { payload: { oldPkgName, newPkgName } }) {
      if (!newPkgName.includes(state.tempProject.basePackage.packageName)) {
        toast.error("Package name must include the base package name");
        return;
     }
     
      state.prevPkgNamebeforeEdit = oldPkgName;
      state.PkgNameAfterEdit = newPkgName;
      
     
    
      function findAndRemovePackage(packages, name) {
        for (let i = 0; i < packages.length; i++) {
          if (packages[i].packageName === name) {
            // Remove the package and return it
            const [removedPackage] = packages.splice(i, 1);
            return removedPackage;
          }
          // Recursively search in childrenPackages
          if (packages[i].childrenPackages && packages[i].childrenPackages.length > 0) {
            const removedPackage = findAndRemovePackage(packages[i].childrenPackages, name);
            if (removedPackage) {
              return removedPackage;
            }
          }
        }
        return null; // Package not found
      }
      
    
    
      function insertPackage(basePkg, parentName, pkg) {
        if (!basePkg.childrenPackages) {
          basePkg.childrenPackages = [];
        }
        state.currentPackages?.map(pkg => {
          if ( pkg.packageName === oldPkgName) {
            pkg.packageName = newPkgName;
          }
          })
        if (basePkg.packageName === parentName ) {
          basePkg.childrenPackages.push(pkg);
          return true; 
        }
        if (!parentName.includes(state.tempProject.basePackage.packageName)) {
        
        
          return false;
        }
        for (let i = 0; i < basePkg.childrenPackages.length; i++) {
          if (basePkg.childrenPackages[i].packageName === parentName) {
            if (!basePkg.childrenPackages[i].childrenPackages) {
              basePkg.childrenPackages[i].childrenPackages = [];
            }
            basePkg.childrenPackages[i].childrenPackages.push(pkg);
            return true;
          }
          // Recursively search in childrenPackages
          if (basePkg.childrenPackages[i].childrenPackages && basePkg.childrenPackages[i].childrenPackages.length > 0) {
            if (insertPackage(basePkg.childrenPackages[i], parentName, pkg)) {
              return true;
            }
          }
        }
        
        
        return false; // Parent package not found
      }
    
      function updatePackageNameAndMove(basePackage, oldName, newName) {
        const oldParts = oldName.split('.');
        const newParts = newName.split('.');
        
        // If the base package itself is being renamed
        if (oldParts.length === 1 && newParts.length === 1) {
          basePackage.packageName = newParts[0];
          return;
        }
    
        const newParentName = newParts.slice(0, -1).join('.');
      
        
        const newPackageName = newName;
    
        // Remove the package from its old location
        const packageToMove = findAndRemovePackage(basePackage.childrenPackages, oldName);
        if (!packageToMove) {
          console.error('Old package not found.');
          return;
        }
    
        // Update the package name
        packageToMove.packageName = newPackageName;
        
        // Insert the package into its new location
        if (!insertPackage(basePackage, newParentName, packageToMove)) {
          console.error('New parent package not found.');
          toast.error("parent package not found");
          return;
        }
      }
    
      // Update the package structure
      updatePackageNameAndMove(state.tempProject.basePackage, oldPkgName, newPkgName);
      
      // Update the current package name if it matches the old name
      if (state.currentPackageName === oldPkgName) {
        state.currentPackageName = newPkgName;
      }
      
      // Update allPackages after package name change
      if (state.tempProject?.basePackage) {
        state.allPackages = getAllPackages(state.tempProject.basePackage) ?? [];
      }
    }
    ,
    
    handleDeletePackage (state, { payload: { pkgName } }) {
    
      // Function to delete package by its name
      const deletePackage = (packages, nameToDelete) => {
        state.currentPackages?.forEach(pkg => {
          if ( pkg.packageName === nameToDelete) {
            state.currentPackages = state.currentPackages.filter(p => p.packageName !== nameToDelete);
          }
          })
          for (let i = 0; i < packages.length; i++) {
              if (packages[i].packageName === nameToDelete) {
                  const deletedPkg = packages.splice(i, 1); 
                  // packages.splice(i, 1);// Remove the package from the array
                  state.deletedPkg = deletedPkg.length > 0 ? deletedPkg[0] : null;
                  return true;
              }
              // Recursively search in childrenPackages
              if (packages[i].childrenPackages && packages[i].childrenPackages.length > 0) {
                  if (deletePackage(packages[i].childrenPackages, nameToDelete)) {
                      // If the package is found and deleted in childrenPackages, no need to continue searching
                      return true;
                  }
              }
          }
          // Package not found
          return false;
      };
      
      // Call deletePackage function
      deletePackage(state.tempProject.basePackage.childrenPackages, pkgName);
  
      // Optionally, update state if needed
      // For example, if you want to update currentPackageName if it's equal to the deleted pkgName
      if (state.currentPackageName === pkgName) {
        state.currentPackageName = "com.example.demo";
        const pkg = deepSearchForPackage(state.tempProject?.basePackage, "com.example.demo");
        state.currentPackages = [...(pkg?.childrenPackages ?? [])];
      }
  
      // Update allPackages after package deletion
      if (state.tempProject?.basePackage) {
        state.allPackages = getAllPackages(state.tempProject.basePackage) ?? [];
      }
  
      // Return updated state or perform any side effects
      return state;
  },
  
  // Update component data for a specific node in a package
  updateComponentData(state, { payload: { pkgName, nodeId, componentData } }: { payload: { pkgName: string; nodeId: string; componentData: any } }) {
    
    const updateNodeInPackage = (pkg: SinglePackage): SinglePackage => {
      if (pkg.packageName === pkgName) {
        const updatedPkg = { ...pkg };
        if (updatedPkg.components) {
          updatedPkg.components = updatedPkg.components.map((node: any) => {
            if (node.id === nodeId) {
              return {
                ...node,
                data: {
                  ...node.data,
                  customData: {
                    ...node.data?.customData,
                    ...componentData,
                  },
                },
              };
            }
            return node;
          });
        }
        return updatedPkg;
      }
      
      if (pkg.childrenPackages && pkg.childrenPackages.length > 0) {
        return {
          ...pkg,
          childrenPackages: pkg.childrenPackages.map(updateNodeInPackage),
        };
      }
      
      return pkg;
    };
    
    if (state.tempProject?.basePackage) {
      state.tempProject = {
        ...state.tempProject,
        basePackage: updateNodeInPackage(state.tempProject.basePackage),
      };
      state.allComponents = getAllComponents(state.tempProject?.basePackage) ?? [];
      // Update allPackages when component data changes (in case package structure changed)
      state.allPackages = getAllPackages(state.tempProject?.basePackage) ?? [];
    }
  },
  
  // Update nodes and edges for a package
  updatePackageNodesAndEdges(state, { payload: { pkgName, nodes, edges } }: { payload: { pkgName: string; nodes?: Node<any, string>[]; edges?: any[] } }) {
    const updatePackageData = (pkg: SinglePackage): SinglePackage => {
      if (pkg.packageName === pkgName) {
        const updatedPkg = { ...pkg };
        if (nodes !== undefined) {
          // Merge customData from existing nodes to preserve latest updates
          // This prevents overwriting componentName and other data updated via updateComponentData
          const existingNodesMap = new Map((pkg.components || []).map((n: any) => [n.id, n]));
          updatedPkg.components = nodes.map((newNode: any) => {
            const existingNode = existingNodesMap.get(newNode.id);
            // If node exists in Redux, preserve its customData (which has latest updates)
            // Only use new node's customData for brand new nodes
            if (existingNode?.data?.customData) {
              return {
                ...newNode,
                data: {
                  ...newNode.data,
                  customData: existingNode.data.customData, // Always use Redux data for existing nodes
                },
              };
            }
            return newNode;
          });
        }
        if (edges !== undefined) {
          updatedPkg.edges = edges;
        }
        return updatedPkg;
      }
      
      if (pkg.childrenPackages && pkg.childrenPackages.length > 0) {
        return {
          ...pkg,
          childrenPackages: pkg.childrenPackages.map(updatePackageData),
        };
      }
      
      return pkg;
    };
    
    if (state.tempProject?.basePackage) {
      state.tempProject = {
        ...state.tempProject,
        basePackage: updatePackageData(state.tempProject.basePackage),
      };
      state.allComponents = getAllComponents(state.tempProject?.basePackage) ?? [];
      // Update allPackages when package nodes/edges change (in case package structure changed)
      state.allPackages = getAllPackages(state.tempProject?.basePackage) ?? [];
    }
  },
  
  // Initialize component data for a node if it doesn't exist
  initComponentData(state, { payload: { pkgName, nodeId, initialData } }: { payload: { pkgName: string; nodeId: string; initialData: any } }) {
    const updateNodeInPackage = (pkg: SinglePackage): SinglePackage => {
      if (pkg.packageName === pkgName) {
        const updatedPkg = { ...pkg };
        if (updatedPkg.components) {
          updatedPkg.components = updatedPkg.components.map((node: any) => {
            if (node.id === nodeId && (!node.data?.customData || Object.keys(node.data.customData).length === 0)) {
              return {
                ...node,
                data: {
                  ...node.data,
                  customData: initialData,
                },
              };
            }
            return node;
          });
        }
        return updatedPkg;
      }
      
      if (pkg.childrenPackages && pkg.childrenPackages.length > 0) {
        return {
          ...pkg,
          childrenPackages: pkg.childrenPackages.map(updateNodeInPackage),
        };
      }
      
      return pkg;
    };
    
    if (state.tempProject?.basePackage) {
      state.tempProject = {
        ...state.tempProject,
        basePackage: updateNodeInPackage(state.tempProject.basePackage),
      };
    }
  },
  },
});

export const { 
  reset,
  addTempProject,
  handleUpdateAllPackages,
  updataTempMetaData,
  handleDeletePackage,
  updateCurrentProject,
  handleChangePkgName,
  updateTempProject,
  initProject,
  handleUpdateCurrentPackages,
  handleChangeCurrentPackage,
  updateRerenderValue,
  updateComponentData,
  updatePackageNodesAndEdges,
  initComponentData,
} = projectSlice.actions;
export default projectSlice.reducer;